module.exports = __webpack_public_path__ + "img/Logo@2x.25c2368d.png";